import { tableElementType } from "./TableElement.js";
const tableToolbarButton = {
  elementType: tableElementType,
  contemberIcon: "table",
  label: "Table",
  title: "Table"
};
export {
  tableToolbarButton
};
//# sourceMappingURL=tableToolbarButtons.js.map
